import './index.scss'
import Swiper from 'swiper/swiper-bundle.min.js'

var swiper = new Swiper(".section1 .mySwiper", {
    spaceBetween: 4,
    slidesPerView: 4,
    direction: 'vertical',

}); 
var swiper2 = new Swiper(".section1 .mySwiper2", {
    thumbs: {
        swiper: swiper,
    },
    navigation: {
        nextEl: ".section1 .swiper-button-next",
        prevEl: ".section1 .swiper-button-prev",
    },
});

var advantage = new Swiper(".section4 .swiper", {
    pagination: {
        el: ".section4 .swiper-pagination",
        type: "fraction",
    },
    navigation: {
        nextEl: ".section4 .swiper-button-next",
        prevEl: ".section4 .swiper-button-prev",
    },
});

var choose = new Swiper(".choose .swiper", {
    slidesPerView: 1,
    loop: true,                 // 开启循环，联动时注意处理复制的slide
    effect: "fade",
        fadeEffect: {
        crossFade: true
    },
    autoplay: {
        delay: 3000,            // 2秒切换一次
        disableOnInteraction: false, // 手动滑动后不停止自动播放
        pauseOnMouseEnter: true, // 鼠标悬停暂停
    },
    speed: 600,   
    
});
// 获取所有自定义tab
const tabs = document.querySelectorAll('.tab-btn');

// 辅助函数：移除所有tab的高亮类
function removeAllActive() {
    tabs.forEach(tab => {
        tab.classList.remove('active');
    });
}

// 给对应索引的tab添加高亮 (注意: 由于loop模式会克隆slide，真实索引需要通过 swiper.realIndex)
function setActiveTabByIndex(realIndex) {
    removeAllActive();
    // realIndex 范围 0 到 (slide总数-1) 对应原始slide
    tabs.forEach(tab => {
        // 获取自定义属性 data-index 并转为数字
        const idx = parseInt(tab.getAttribute('data-index'), 10);
        if (idx === realIndex) {
            tab.classList.add('active');
        }
    });
}

// 1. 监听swiper的slide切换事件 (实时更新)
choose.on('slideChange', function() {
    // 在loop模式下，realIndex 是原始slide的索引，非常可靠
    const realIdx = choose.realIndex;
    setActiveTabByIndex(realIdx);
});

// 2. 初始化时立即同步一次（因为自动播放可能还没触发slideChange）
//    Swiper初始化后需要稍微延迟确保渲染完成，但realIndex已经可用
setTimeout(() => {
    const initialRealIndex = choose.realIndex;  // 初始应该是0 (除非设置了initialSlide)
    setActiveTabByIndex(initialRealIndex);
}, 10);

// 3. 可选：点击tab手动切换到对应slide (同时也会触发上面的slideChange，高亮自然更新)
tabs.forEach(tab => {
    tab.addEventListener('click', function(e) {
        const idx = parseInt(this.getAttribute('data-index'), 10);
        // 使用slideToLoop 以兼容loop模式 (内部自动处理克隆偏移)
        // 参数: 索引, 速度, 是否强制执行
        choose.slideToLoop(idx, 600); 
        // 由于slideChange事件会触发高亮，这里不再手动改类
        // 但是注意：如果点击的是当前激活的tab，slide并不会切换，也就不会触发slideChange
        // 此时高亮状态本就应该保持不变，所以没问题。
    });
});
